module.exports = __webpack_public_path__ + "static/phone-carrier-product-2-7a8d947d97f242788733d9901408087f.png";